import { writesApi } from './api';
import type { LoginRequest, AuthResponse, UserContextResponse } from '@apptypes/index';

// All auth endpoints → Spring Boot :8080
export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await writesApi.post<AuthResponse>('/auth/login', credentials);

    if (response.accessToken) {
      localStorage.setItem('auth_token', response.accessToken);
      localStorage.setItem('auth_refresh_token', response.refreshToken);
      localStorage.setItem('auth_user', JSON.stringify(response.user));
    }

    return response;
  },

  refreshToken: async (): Promise<AuthResponse> => {
    const refreshToken = localStorage.getItem('auth_refresh_token');
    return writesApi.post<AuthResponse>('/auth/refresh', { refreshToken });
  },

  logout: async (): Promise<void> => {
    try {
      await writesApi.post('/auth/logout');
    } catch {
      // Ignore errors; we're clearing local state regardless
    }
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_refresh_token');
    localStorage.removeItem('auth_user');
  },

  getCurrentUser: (): UserContextResponse | null => {
    const userStr = localStorage.getItem('auth_user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr) as UserContextResponse;
    } catch {
      return null;
    }
  },

  getToken: (): string | null => localStorage.getItem('auth_token'),

  isAuthenticated: (): boolean => !!localStorage.getItem('auth_token'),

  /**
   * Fetch fresh user context from Spring Boot.
   * Direct call to :8080 (bypasses nginx GET→FastAPI routing).
   */
  fetchUserContext: async (): Promise<UserContextResponse> => {
    return writesApi.get<UserContextResponse>('/me');
  },
};
